//
import { required } from '@/services/validations'

//
import PurchaseOrderHeaders from './headers'

//
export default ({ invoice_number }) => [
    {
        name: 'invoice_number',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Folio',
        },
    },
    {
        name: 'pch_provider_alias_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Proveedor',
        },
    },
    {
        name: 'pch_provider_branch_offices_address',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Sucursal del proveedor',
        },
    },
    {
        name: 'emission_date',
        type: 'date-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Fecha de emisión',
        },
    },
    {
        name: 'pch_payment_condition_type',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Condición de pago',
        },
    },
    {
        name: 'is_exent_str',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Exenta',
        },
    },
    {
        name: 'is_replaced_str',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Remplazada',
        },
    },
    {
        name: 'is_canceled_str',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Cancelada',
        },
    },
    {
        name: 'pch_purchase_order_has_invoice_numbers',
        type: 'data-table-model',
        flex: {
            'pt-0': true,
            xs12: true,
            'd-grid': true,
        },
        props: {
            class: 'v-card elevation-2 mb-4',
            headers: PurchaseOrderHeaders,
            noActions: true,
            noDataText: 'Sin ordenes de compra.',
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,
            paramFilter: {
                invoice_number,
            },
            showNativePagination: true,
            toolbarTitle: 'Lista de ordenes de compra incluidas en la factura',
            toolbarColor: 'primary',
            toolbarDark: true,
            toolbarDense: true,
            rules: [required],
        },
    },
    {
        name: 'description',
        type: 'textarea',
        flex: {
            xs12: true,
        },
        props: {
            noDataText: 'Sin empleados.',
            label: 'Descripción',
            rules: [required],
        },
    },
    {
        name: 'payment_date',
        type: 'date-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Fecha de pago',
        },
    },
    {
        name: 'new_subtotal',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Neto',
        },
    },
    {
        name: 'iva',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'IVA',
        },
    },
    {
        name: 'total',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Total',
        },
    },
]
